<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="2.5in" height="3.5in" viewBox="-120 -168 240 336" preserveAspectRatio="none" class="card" face="TH">
   <symbol id="H" viewBox="-600 -600 1200 1200" preserveAspectRatio="xMinYMid">
      <path d="M0 -300C0 -400 100 -500 200 -500C300 -500 400 -400 400 -250C400 0 0 400 0 500C0 400 -400 0 -400 -250C-400 -400 -300 -500 -200 -500C-100 -500 0 -400 -0 -300Z" fill="red"/>
   </symbol>
   <symbol id="HT" viewBox="-500 -500 1000 1000" preserveAspectRatio="xMinYMid">
      <path d="M-260 430L-260 -430M-50 0L-50 -310A150 150 0 0 1 250 -310L250 310A150 150 0 0 1 -50 310Z" stroke="red" stroke-width="80" stroke-linecap="square" stroke-miterlimit="1.5" fill="none"/>
   </symbol>
   <rect width="239" height="335" x="-119.5" y="-167.5" rx="12" ry="12" fill="white" stroke="black"/>
   <use xlink:href="#HT" height="32" width="32" x="-114.4" y="-156"/>
   <use xlink:href="#H" height="26.769" width="26.769" x="-111.784" y="-119"/>
   <use xlink:href="#H" height="70" width="70" x="-87.501" y="-135.501"/>
   <use xlink:href="#H" height="70" width="70" x="17.501" y="-135.501"/>
   <use xlink:href="#H" height="70" width="70" x="-87.501" y="-68.5"/>
   <use xlink:href="#H" height="70" width="70" x="17.501" y="-68.5"/>
   <use xlink:href="#H" height="70" width="70" x="-35" y="-102"/>
   <g transform="rotate(180)">
      <use xlink:href="#HT" height="32" width="32" x="-114.4" y="-156"/>
      <use xlink:href="#H" height="26.769" width="26.769" x="-111.784" y="-119"/>
      <use xlink:href="#H" height="70" width="70" x="-87.501" y="-135.501"/>
      <use xlink:href="#H" height="70" width="70" x="17.501" y="-135.501"/>
      <use xlink:href="#H" height="70" width="70" x="-87.501" y="-68.5"/>
      <use xlink:href="#H" height="70" width="70" x="17.501" y="-68.5"/>
      <use xlink:href="#H" height="70" width="70" x="-35" y="-102"/>
   </g>
</svg>
